import { ShieldCheck, Landmark, ScanSearch, KeyRound, Globe, BookOpenCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { SECURITY } from "../../lib/content";

const icons = { ShieldCheck, Landmark, ScanSearch, KeyRound, Globe, BookOpenCheck };

export const Security = () => (
  <section id="security" className="bg-[#FAFAFB] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4">Trust &amp; compliance</p>
        <h2 className="font-heading max-w-2xl text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
          Compliance isn't a checkbox. <span className="text-slate-400">It's the product.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 overflow-hidden rounded-3xl border border-slate-200 bg-white sm:grid-cols-2 lg:grid-cols-3">
        {SECURITY.map((s, i) => {
          const Icon = icons[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.05}>
              <div
                data-testid={`security-item-${i}`}
                className="group h-full border-b border-r border-slate-100 p-8 transition-colors duration-300 hover:bg-[#E8EDFF]/40 lg:p-10"
              >
                <Icon size={24} strokeWidth={1.6} className="text-[#3B5FE8]" />
                <h3 className="font-heading mt-6 text-lg font-medium text-[#0A0C14] lg:text-xl">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
